import React from 'react';
import { oneOf } from 'prop-types';
import type { TitleProperties } from './style';
import * as S from './style';

function Title({ size = 'md', ...properties }: TitleProperties) {
  return <S.Title size={size} {...properties} />;
}

Title.propTypes = {
  size: oneOf(['sm', 'md', 'lg']),
};

Title.defaultProps = {
  size: 'md',
};

export default Title;
